import React from 'react';
type Props = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
  className?: string;
};
export function SectionLabel({
  children,
  tone = 'dark',
  className = ''
}: Props) {
  return <p className={`eyebrow flex items-center gap-3 ${tone === 'dark' ? 'text-ink' : 'text-white/70'} ${className}`} data-id="element-467" data-mp="1cp2c0334b7tq">
      <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-468" data-mp="17ppln8d1fime" />
      {children}
    </p>;
}